import { render, staticRenderFns } from "./BlogIndex.vue?vue&type=template&id=68b8fe1b&scoped=true"
import script from "./BlogIndex.vue?vue&type=script&lang=js"
export * from "./BlogIndex.vue?vue&type=script&lang=js"
import style0 from "./BlogIndex.vue?vue&type=style&index=0&id=68b8fe1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8fe1b",
  null
  
)

export default component.exports